// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../components/Table";
// Engine
import { axiosAPI } from "../../../engine/config/axios";

const UserCompensationsTable:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  const gridParams = {
    grids: [{ name: 'userCompensation', hashCache }],
  }

  return <Table
    api={axiosAPI.userCompensation.table}
    apiParams={apiParams}
    gridName="userCompensation"
    gridParams={gridParams}
    sortingMode="multiple"
  />;
}

function UserCompensationsTablePortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<UserCompensationsTable hashCache={Root?.dataset.hashCache}  />, Root) : null;
}

export default UserCompensationsTablePortal;
